import React, { useEffect, useMemo, useState } from 'react';
import Separator from '../../../../../components/Separator/Separator';
import { useTranslation } from 'react-i18next';
import { Col, Form, FormGroup, FormLabel, Row } from 'react-bootstrap';
import CustomRadioGroup from '../../../../../components/CustomRadioGroup/CustomRadioGroup';

const _3DVisionCheck = ({ register, data, control, setValue }) => {
  const { t } = useTranslation();
  const [bValue, setBValue] = useState( data?._3DVisionCheck?.b);

  const values = useMemo(
    () => [
      {
        label: t('yes'),
        checked: bValue === true,
        value: true,
      },
      {
        label: t('no'),
        checked: bValue === false,
        value: false,
      },
    ],
    [bValue]
  );

  
  useEffect(() => {
    setValue('_3DVisionCheck.b', data?._3DVisionCheck?.b);
  }, []);

  return (
    <>
      <Separator text={t('examinations:screenings.3DVisionCheck.title')} hint={t('examinations:screenings.3DVisionCheck.hint')}/>
      <Row>
        <Col md={6}>
          <h5>{t('examinations:bothEyes')}</h5>
          <CustomRadioGroup
            label={t('examinations:screenings.3DVisionCheck.label')}
            labelClass="d-block"
            items={values}
            groupProps={{ className: 'mb-3' }}
            controlProps={{
              name: '_3DVisionCheck.b',
              control,
              rules: { validate: v => v !== undefined || 'required' },
              defaultValue: data?._3DVisionCheck?.b,
            }}
            onChange={v => {
              setBValue(v);
              setValue('_3DVisionCheck.b', v);
            }}
          />
        </Col>
      </Row>
    </>
  );
};
export default _3DVisionCheck;
